import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogContent,
  DialogActions,
} from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { BasicButton } from '@components/common/BasicButton';
import { useDeleteConfirmDialogStyles } from './DeleteConfirmDialog.styles';

interface DeleteConfirmDialogProps {
  open: boolean;
  eventTitle: string;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
  loading?: boolean;
  error?: string | null;
}

export const DeleteConfirmDialog = ({
  open,
  eventTitle,
  onConfirm,
  onCancel,
  loading = false,
  error = null,
}: DeleteConfirmDialogProps) => {
  const { t } = useTranslation('dashboard');
  const styles = useDeleteConfirmDialogStyles();

  return (
    <Dialog open={open} onOpenChange={(_, data) => !data.open && onCancel()}>
      <DialogSurface aria-describedby="delete-dialog-description">
        <DialogBody>
          <DialogTitle>{t('dialogs.delete.title')}</DialogTitle>
          <DialogContent id="delete-dialog-description">
            {t('dialogs.delete.description')}
            <br />
            <strong>{eventTitle}</strong>
          </DialogContent>
          <DialogActions>
            <BasicButton
              variant="primary"
              size="medium"
              onClick={() => void onConfirm()}
              disabled={loading}
            >
              {loading ? t('common:common.loading') : t('dialogs.delete.confirm')}
            </BasicButton>
            <BasicButton variant="secondary" size="medium" onClick={onCancel} disabled={loading}>
              {t('dialogs.delete.cancel')}
            </BasicButton>
          </DialogActions>
          {error && (
            <p className={styles.errorText} role="alert">
              {error}
            </p>
          )}
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

DeleteConfirmDialog.displayName = 'DeleteConfirmDialog';
